import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import { AppThemeProvider } from '@datanomik/commons-ui';

import reportWebVitals from './reportWebVitals';

import Index from './views/base/Index';

import './styles/styles.scss';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HashRouter>
    <AppThemeProvider>
      <Index />
    </AppThemeProvider>
  </HashRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
